import uploadspracticeAreaspagebannerbgimageshutterstock_2243996415CroppedJpg from "$lib/data/generated/uploads/practice areas/PageBanner/bgImage/shutterstock_2243996415-cropped.jpg";

export const uploads = {
  "uploads/practice areas/PageBanner/bgImage/shutterstock_2243996415-cropped.jpg": uploadspracticeAreaspagebannerbgimageshutterstock_2243996415CroppedJpg
};